// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__7baIt","rootCenter":"LoadMoreObserver_rootCenter__2-vaV","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__2tjJu"};